<template>
  <div>
    <headerSection></headerSection>
    <div class="partner-page">
      <!-- Hero Section -->
      <div class="partner-hero">
        <div class="hero-bg-effects">
          <div class="floating-ball ball-1"></div>
          <div class="floating-ball ball-2"></div>
          <div class="floating-ball ball-3"></div>
        </div>
        <div class="container">
          <div class="hero-content">
            <div class="hero-icon">🤝</div>
            <h1 class="hero-title">
              <span class="title-glow">{{ $t('link_partner') }}</span>
            </h1>
            <p class="hero-description">
              {{ $t('partner_page.hero_description') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="container partner-content">
        <!-- Banner Section -->
        <div class="banner-section">
          <div class="banner-card">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/fun-beyond.firebasestorage.app/o/images%2F-N5Zi0KwC5SYe4y7Pzwk.png?alt=media&token=0d07b066-89f6-4d06-ad02-c1d28cb8f91a"
              class="banner-image"
              alt="Partner Banner"
            >
          </div>
        </div>

        <!-- Referral Link Section -->
        <div class="referral-section">
          <div class="referral-card">
            <div class="referral-label">
              <span class="link-icon">🔗</span>
              <span class="link-text">{{ $t('deposit_title3') }}</span>
            </div>
            <div class="input-group">
              <input
                id="copyTarget3"
                type="text"
                readonly
                class="referral-input"
                :value="partnerReferralUrl"
              >
              <button
                id="copyButton3"
                class="copy-btn"
                v-clipboard:copy="partnerReferralUrl"
                v-clipboard:success="clipboardSuccessHandler"
              >
                <i class="fa fa-copy"></i>
                <span class="copy-text">{{ $t('copy') }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Stats Section -->
        <div class="stats-section">
          <h3 class="section-title">
            <span class="title-icon">📊</span>
            {{ $t('partner_title') }}
          </h3>

          <div class="stats-grid">
            <!-- Friends Count -->
            <div class="stat-card">
              <div class="stat-icon-wrapper purple">
                <span class="stat-icon">👥</span>
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ $t('partner_title2') }}</span>
                <span class="stat-value purple">{{ (friends) ? friends.length : 0 }}</span>
              </div>
              <button class="stat-action-btn" @click="showlevel(1)">
                <img src="../assets/images/analysis.png" width="24" alt="Analysis">
              </button>
            </div>

            <!-- Income -->
            <div class="stat-card">
              <div class="stat-icon-wrapper gold">
                <span class="stat-icon">💰</span>
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ $t('partner_title4') }}</span>
                <span class="stat-value gold">{{ (partner && partner.total1) ? numberWithCommas(partner.total1) : 0 }}</span>
              </div>
            </div>

            <!-- Total -->
            <div class="stat-card featured">
              <div class="stat-icon-wrapper featured-icon">
                <span class="stat-icon">🏆</span>
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ $t('partner_title6') }}</span>
                <span class="stat-value featured-value">{{ (partner && partner.total) ? numberWithCommas(partner.total) : 0 }}</span>
              </div>
              <div class="stat-badge">฿</div>
              <div class="featured-glow"></div>
            </div>
          </div>
        </div>

        <!-- Transfer Button -->
        <div class="transfer-section">
          <button
            class="transfer-btn"
            :class="{ 'disabled': !partner || !partner.total || partner.total <= 0 }"
            @click="movePartnerToWallet()"
            :disabled="!partner || !partner.total || partner.total <= 0"
          >
            <span class="transfer-icon">💳</span>
            <span class="transfer-text">{{ $t('partner_title7') }}</span>
            <span class="btn-shine"></span>
          </button>
        </div>

        <!-- Info Section -->
        <div class="info-section" v-if="detail">
          <div class="info-card">
            <div class="info-content" v-html="nl2br(detail)"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal-overlay"
      :class="{ 'show': showdetail }"
      @click.self="closeDetail()"
    >
      <div class="modal-container">
        <button type="button" class="modal-close" @click="closeDetail()">
          <i class="fas fa-times"></i>
        </button>

        <div class="modal-header">
          <h2 class="modal-title">{{ titleDetail }}</h2>
          <p class="modal-subtitle">{{ $t('data_summary_yesterday') }}</p>
        </div>

        <div class="modal-body">
          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th>{{ $t('table_code') }}</th>
                  <th>{{ $t('table_date') }}</th>
                  <th>{{ $t('table_deposit') }}</th>
                  <th>{{ $t('table_withdraw') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in history" :key="index">
                  <td>{{ item.friend }}</td>
                  <td>{{ item.createdateShow }}</td>
                  <td class="text-right">{{ numberWithCommas(item.deposit) }}</td>
                  <td class="text-right">{{ numberWithCommas(item.withdraw) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="modal-footer">
            <p class="contact-text">
              {{ $t('contact_problem') }}&nbsp;
              <a :href="adminContactLineLink" class="contact-link" target="_blank" rel="noopener">
                <u>{{ $t('contact_customer_service') }}</u>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
const axios = require('axios').default

const normalizeDomain = (value) => {
  const rawValue = (value || '').toString().trim().toLowerCase()
  if (!rawValue) return ''

  return rawValue
    .replace(/^https?:\/\//, '')
    .replace(/^\/\//, '')
    .split('/')[0]
    .split('?')[0]
    .split('#')[0]
    .replace(/:\d+$/, '')
}
export default {
  name: 'Partner',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
      const _user = JSON.parse(user)
      this.$store.dispatch('user/setUser', _user).catch(err => { console.error(err) })
    } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
    }
  },
  data: function () {
    return {
      friends: [],
      partner: [],
      showdetail: false,
      titleDetail: '',
      history: [],
      detail: '',
      disabled: false
    }
  },
  mounted () {
    this.scrollToTop()
    this.getPartner()
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    adminContactLineLink () {
      return this.$store.getters['settings/adminContactLineLink'] || this.$store.getters['settings/linkLine']
    },
    partnerReferralHost () {
      const configuredHost = normalizeDomain(this.$store.getters['settings/partnerReferralHost'])
      if (configuredHost) return configuredHost

      const activeDomains = this.$store.getters['settings/activeDomains'] || []
      const firstActiveHost = activeDomains.length ? normalizeDomain(activeDomains[0].host) : ''
      return firstActiveHost || normalizeDomain(window.location.hostname) || 'funbeyond.cc'
    },
    partnerReferralUrl () {
      const code = this.user && this.user.code ? this.user.code : ''
      return `https://${this.partnerReferralHost}/register?ref=${code}`
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    movePartnerToWallet () {
      if (this.partner.total && this.partner.key && !this.disabled) {
        this.disabled = true;
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally((res) => {
          setTimeout(async () => {
            axios.get(`https://api.funbeyond.cc/qpartner/partner/${this.partner.key}`)
            setTimeout(() => {
              this.getPartner()
              this.$store.commit('user/SET_LOADING', false)
            }, 2000)
          }, 2000)
        })
        setTimeout(() => {
          this.disabled = false;
        }, 2000);
      }
    },
    clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: this.$t('copy_success') })
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async getPartner () {
      this.detail = (await firebase.database().ref('/partner/detail').once('value')).val()
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.partner = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.partner = data
          })
        })
        firebase.firestore().collection('friends').where('userkey', '==', user.key).get().then((result) => {
          result.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.friends.push(data)
          })
        })
      }
    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    async showlevel (level) {
      const history = []
      const deposit = []
      const withdraw = []
      if (level === 1) {
        this.titleDetail = this.$t('partner_page.level1_title')
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            deposit[doc.data().code] = doc.data().total
          })
        })
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            withdraw[doc.data().code] = doc.data().total
          })
        })
        if (this.friends) {
          for (const x in this.friends) {
            if (deposit[this.friends[x].friend]) {
              this.friends[x].deposit = deposit[this.friends[x].friend]
            } else {
              this.friends[x].deposit = 0
            }
            if (withdraw[this.friends[x].friend]) {
              this.friends[x].withdraw = withdraw[this.friends[x].friend]
            } else {
              this.friends[x].withdraw = 0
            }
            this.friends[x].createdateShow = moment().add(-1, 'days').format('DD MMM,YY')
            history.push(this.friends[x])
          }
        }
      } else {
        this.titleDetail = this.$t('partner_page.level2_title')
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            deposit[doc.data().code] = doc.data().total
          })
        })
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            withdraw[doc.data().code] = doc.data().total
          })
        })
        if (this.user.level2) {
          for (const x in this.user.level2) {
            if (deposit[this.user.level2[x].code]) {
              this.user.level2[x].deposit = deposit[this.user.level2[x].code]
            } else {
              this.user.level2[x].deposit = 0
            }
            if (withdraw[this.user.level2[x].code]) {
              this.user.level2[x].withdraw = withdraw[this.user.level2[x].code]
            } else {
              this.user.level2[x].withdraw = 0
            }
            this.user.level2[x].createdateShow = moment().add(-1, 'days').format('DD MMM,YY')
            history.push(this.user.level2[x])
          }
        }
      }
      this.history = history
      this.showdetail = true
    },
    closeDetail () {
      this.showdetail = false
    }
  }
}
</script>

<style scoped>
/* ============================================
   PARTNER PAGE - MODERN DESIGN
   ============================================ */

.partner-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1b1b41 0%, #492666 50%, #2b2727 100%);
  padding-bottom: 100px;
}

/* ============================================
   HERO SECTION
   ============================================ */

.partner-hero {
  position: relative;
  padding: 40px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg,
    rgba(131, 9, 162, 0.1) 0%,
    transparent 100%
  );
}

.hero-bg-effects {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
}

.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #8309a2, #ffc107);
  top: -50px;
  left: -50px;
  animation: float1 6s ease-in-out infinite;
}

.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #fe8a02, #ffc107);
  top: 50%;
  right: -30px;
  animation: float2 8s ease-in-out infinite;
}

.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #492666, #8309a2);
  bottom: -20px;
  left: 30%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-20px, -30px) scale(1.1); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(20px, -20px); }
}

.hero-content {
  text-align: center;
  position: relative;
  z-index: 1;
}

.hero-icon {
  font-size: 60px;
  margin-bottom: 15px;
  animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.hero-title {
  margin: 0 0 15px;
}

.title-glow {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #ce93d8, #8309a2, #ce93d8);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: purpleShine 3s linear infinite;
}

@keyframes purpleShine {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}

.hero-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

/* ============================================
   PARTNER CONTENT
   ============================================ */

.partner-content {
  padding: 20px 15px;
}

/* ============================================
   BANNER SECTION
   ============================================ */

.banner-section {
  margin-bottom: 30px;
}

.banner-card {
  background: linear-gradient(135deg, rgba(131, 9, 162, 0.2), rgba(73, 38, 102, 0.15));
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 20px;
  padding: 20px;
  overflow: hidden;
  position: relative;
}

.banner-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(131, 9, 162, 0.1), transparent);
  transform: rotate(45deg);
  animation: shimmer 4s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%) rotate(45deg); }
  100% { transform: translateX(100%) rotate(45deg); }
}

.banner-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
  position: relative;
  z-index: 1;
}

/* ============================================
   REFERRAL SECTION
   ============================================ */

.referral-section {
  margin-bottom: 30px;
}

.referral-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 16px;
  padding: 20px;
}

.referral-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}

.link-icon {
  font-size: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
}

.referral-input {
  flex: 1;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 12px 16px;
  color: #fff;
  font-size: 14px;
  font-family: 'Kanit', sans-serif;
}

.copy-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #8309a2, #492666);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(131, 9, 162, 0.3);
}

.copy-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(131, 9, 162, 0.4);
}

.copy-btn i {
  font-size: 16px;
}

/* ============================================
   STATS SECTION
   ============================================ */

.stats-section {
  margin-bottom: 30px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
}

.title-icon {
  font-size: 24px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.stat-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 20px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.stat-card.featured {
  grid-column: span 2;
  background: linear-gradient(135deg, rgba(131, 9, 162, 0.15), rgba(73, 38, 102, 0.1));
  border-color: rgba(131, 9, 162, 0.4);
}

.stat-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.stat-icon-wrapper.purple {
  background: linear-gradient(135deg, rgba(131, 9, 162, 0.2), rgba(156, 39, 176, 0.1));
}

.stat-icon-wrapper.gold {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.2), rgba(255, 152, 0, 0.1));
}

.stat-icon-wrapper.featured-icon {
  background: linear-gradient(135deg, rgba(131, 9, 162, 0.2), rgba(255, 193, 7, 0.1));
}

.stat-icon {
  font-size: 24px;
}

.stat-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

.stat-value.purple {
  color: #ce93d8;
  text-shadow: 0 0 15px rgba(206, 147, 216, 0.5);
}

.stat-value.gold {
  color: #ffc107;
  text-shadow: 0 0 15px rgba(255, 193, 7, 0.5);
}

.stat-value.featured-value {
  color: #ffc107;
  text-shadow: 0 0 15px rgba(255, 193, 7, 0.5);
}

.stat-action-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.stat-action-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.stat-action-btn img {
  display: block;
}

.stat-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 28px;
  color: rgba(255, 193, 7, 0.3);
  font-weight: bold;
}

.featured-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  background: radial-gradient(circle, rgba(131, 9, 162, 0.2) 0%, transparent 70%);
  transform: translate(-50%, -50%);
  pointer-events: none;
}

/* ============================================
   TRANSFER SECTION
   ============================================ */

.transfer-section {
  margin-bottom: 30px;
}

.transfer-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 18px 32px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #8309a2 0%, #492666 100%);
  border: none;
  border-radius: 50px;
  cursor: pointer;
  overflow: hidden;
  box-shadow:
    0 4px 15px rgba(131, 9, 162, 0.4),
    0 0 30px rgba(131, 9, 162, 0.2);
  transition: all 0.3s ease;
}

.transfer-btn:hover:not(.disabled) {
  transform: translateY(-2px);
  box-shadow:
    0 6px 20px rgba(131, 9, 162, 0.5),
    0 0 40px rgba(131, 9, 162, 0.3);
}

.transfer-btn.disabled {
  background: linear-gradient(135deg, #555, #444);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
  box-shadow: none;
}

.transfer-icon {
  font-size: 24px;
}

.btn-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shine 3s ease-in-out infinite;
}

.transfer-btn.disabled .btn-shine {
  display: none;
}

@keyframes shine {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

/* ============================================
   INFO SECTION
   ============================================ */

.info-section {
  margin-bottom: 30px;
}

.info-card {
  padding: 25px;
  background: linear-gradient(135deg,
    rgba(131, 9, 162, 0.1) 0%,
    rgba(73, 38, 102, 0.05) 100%
  );
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 20px;
}

.info-content {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.8;
  text-align: center;
}

/* ============================================
   MODAL
   ============================================ */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.modal-overlay.show {
  opacity: 1;
  visibility: visible;
}

.modal-container {
  width: 90%;
  max-width: 700px;
  max-height: 80vh;
  background: linear-gradient(135deg, #1b1b41, #2b2727);
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 24px;
  overflow: hidden;
  position: relative;
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg);
}

.modal-header {
  padding: 30px 30px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #ce93d8;
  margin: 0 0 10px;
}

.modal-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.modal-body {
  padding: 20px 30px 30px;
  overflow-y: auto;
  max-height: calc(80vh - 180px);
}

.table-container {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Kanit', sans-serif;
}

.data-table thead {
  background: linear-gradient(135deg, #8309a2, #492666);
}

.data-table th {
  padding: 14px 12px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
}

.data-table tbody tr {
  background: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.data-table tbody tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.02);
}

.data-table tbody tr:hover {
  background: rgba(131, 9, 162, 0.2);
}

.data-table td {
  padding: 12px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.data-table td.text-right {
  text-align: right;
}

.modal-footer {
  padding-top: 20px;
  text-align: center;
}

.contact-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.contact-link {
  color: #ce93d8;
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: #ffc107;
}

/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 480px) {
  .hero-icon {
    font-size: 48px;
  }

  .title-glow {
    font-size: 24px;
  }

  .banner-card {
    padding: 15px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card.featured {
    grid-column: span 1;
  }

  .stat-value {
    font-size: 22px;
  }

  .input-group {
    flex-direction: column;
  }

  .modal-container {
    width: 95%;
  }

  .modal-header,
  .modal-body {
    padding: 20px 15px;
  }

  .data-table th,
  .data-table td {
    padding: 10px 8px;
    font-size: 12px;
  }
}

@media (min-width: 769px) {
  .partner-content {
    max-width: 600px;
    margin: 0 auto;
  }

  .title-glow {
    font-size: 32px;
  }
}
</style>
